import React from 'react';
import UserCard from 'components/users/UserCard';
import { ResourceCardElement } from 'components/ResourceCardElements';
import EmployeeType from 'types/employee';
import { stringifyList } from '../../../../../utils';

const EmployeeCard = ({ employee }) =>
  <UserCard user={employee} type="employees">
    <ResourceCardElement
      title="Workroom(s)"
      size="small"
      value={stringifyList(employee.workrooms) || 'No Workroom'}
    />
    <ResourceCardElement
      title="Position"
      size="medium"
      value={employee.position || 'No Position'}
    />
  </UserCard>;

EmployeeCard.propTypes = {
  employee: EmployeeType.isRequired,
};

export default EmployeeCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/employees/components/employeeCard.jsx